import script from "./Notification.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notification.vue?vue&type=script&setup=true&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=4247454f&lang=scss&scoped=true"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4247454f"]])

export default __exports__